import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';
import { useBranding } from '@/lib/branding/BrandingProvider';

export interface NeuraxCompanyCode {
  code: string;
  is_active: boolean;
  uses_count: number;
  max_uses: number | null;
  expires_at: string | null;
}

async function fetchCompanyCode(companyId: string): Promise<NeuraxCompanyCode | null> {
  const { data, error } = await supabase
    .schema('neurax' as never)
    .from('company_codes' as never)
    .select('code, is_active, uses_count, max_uses, expires_at')
    .eq('b2b_company_id', companyId)
    .eq('is_active', true)
    .order('created_at', { ascending: false })
    .limit(1);

  if (error) throw new Error(`company_codes: ${error.message}`);
  const rows = (data ?? []) as unknown as NeuraxCompanyCode[];
  return rows[0] ?? null;
}

export function useCompanyCode() {
  const { companyId } = useBranding();
  return useQuery({
    queryKey: ['neurax', 'company-code', companyId],
    queryFn: () => fetchCompanyCode(companyId),
    staleTime: 5 * 60_000,
  });
}
